import { permissionCheck, realPermissionCheck } from "./permission-check";

export const buildCoordinatorAdmin = (navigation, strings,permissions,onClick,flags = []) => {
  let baseUrl = navigation.region
    ? `/areas/${navigation.area.id}/regions/${navigation.region.id}`
    : `/areas/${navigation.area.id}/regions/na`;
  baseUrl = `${baseUrl}/coordinators/${navigation.coordinator.id}`;

  const item = {
    type: "group",
    label: strings.programAdministration,
    "data-id": "accordion-coordinator-admin-group",
    items: [],
  };
  const items = item.items;
  if (permissionCheck(navigation, "readRegionFaculty")) {
    items.push({
      id:11,
      type: "link",
      "data-id": "accordion-coordinator-admin-faculty",
      label: strings.faculty,
      href: `${baseUrl}/faculty`,
      onClick:(e) => {
        onClick({
          event:e,
          href: `${baseUrl}/faculty`,
        });
      }
    });
  }
  const canManage = realPermissionCheck(permissions, "CanEditProgramSupplemental", navigation.coordinator.id);
  if (canManage) {
    item.items.push({
      id:12,
      type:"link",
      label: strings.instituteHubs,
      "data-id":"accordian-institute-hubs",
      href:`${baseUrl}/institute-hubs`,
      onClick:(e) => {
        onClick({
          event:e,
          href: `${baseUrl}/institute-hubs`,
        });
      }
    });
  }
  return item;
};
